import React from 'react';
import { Link } from 'react-router-dom'; 
import '../Components/Navbar.css';
import logo from '../Components/Images/zp logo.png';
import icon from './Images/icon.png';

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="navbar-left">
        <img src={logo} alt="zpLogo" className="navbar-logo" />
        <span className="navbar-title">Paper Setter</span>
      <Link to="/profile" className="navbar-username-link">
    <span className="navbar-username"></span>
  </Link>
        {/* <Link to="/profile">
          <img src={icon} alt="Profile" className="navbar-profile-img" />
        </Link> */}
      </div>
      </div>
    
  );
};

export default Navbar;
